import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconH1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="h1, heading, headline"><path d="M2.75 4.75V12V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.25 4.75V12V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.25 12H2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18 13.5L20.9 10.75H21.25V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconH1;
